import { useState, useEffect } from "react";
import { Form, Table } from "react-bootstrap";
import { contactServices } from "../../APIServices/SitePilotManagement/contactServices";
import Moment from "react-moment";
import AddContact from "./AddContact";
import ToolBar from "../Componant/ToolBar";
import UpdateContact from "./UpdateContact";
import ContactDetails from "./ContactDetails";
import UseToggle from "../../Hooks/UseToggle";

const ContactData = ({currentUserData}) => {
  const toggles = UseToggle();
  const [search, setSearch] = useState("");
  const [loader, setLoader] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [contactData, setContactData] = useState("");
  const [contactCount, setContactCount] = useState(0);
  const [contactIds, setContactIds] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [hoverId, setHoverId] = useState(null);

  const toggleSingle = (id) => {
    setContactIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  };

  const toggleAll = () => {
    if (contactIds.length === contacts.length) {
      setContactIds([]);
    } else {
      setContactIds(contacts.map((c) => c.userId));
    }
  };

  const isAllChecked =
    contacts.length > 0 && contactIds.length === contacts.length;
  const isChecked = (id) => contactIds.includes(id);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(contactCount / itemsPerPage);

  const start = (pageNumber - 1) * itemsPerPage + 1;
  const end = Math.min(pageNumber * itemsPerPage, contactCount);

  const getContactList = async () => {
    setLoader(true);
    let data = await contactServices.getContactList(
      "active",
      search,
      pageNumber,
      itemsPerPage,
    );
    setContacts(data?.data || []);
    setContactCount(data?.count || 0);
    setLoader(false);
  };

  useEffect(() => {
    getContactList();
  }, [search, pageNumber, itemsPerPage]);

  return (
    <>
      <div className="w-100" style={{ height: "calc(100vh - 57px)" }}>
        <ToolBar
          toggles={toggles}
          search={search}
          setSearch={setSearch}
          checkedIds={contactIds}
          setCheckedIds={setContactIds}
          showPreview={showPreview}
          setShowPreview={setShowPreview}
          setSelected={setContactData}
          start={start}
          end={end}
          totalItems={contactCount}
          page={pageNumber}
          setPage={setPageNumber}
          setPageSize={setItemsPerPage}
          totalPages={totalPages}
          addField
          editField
        />
        <div className={`contacts-layout ${showPreview ? "with-preview" : ""}`}>
          <div
            className={`table-section overflow-auto bg-white ${showPreview ? "border-end" : ""}`}
            style={{ height: "calc(100vh - 108px)" }}
          >
            <Table
              hover
              className="contacts-table mb-0"
              style={{ verticalAlign: "middle" }}
            >
              <thead>
                <tr>
                  <th>
                    <div className="d-flex align-items-center gap-2">
                      <div className="px-2">
                        <Form.Check
                          type="checkbox"
                          checked={isAllChecked}
                          onChange={toggleAll}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </div>
                      <div>Contact Details</div>
                    </div>
                  </th>
                  {!contactData && (
                    <>
                      <th>Phone</th>
                      <th>Organization</th>
                      <th>Total Page View</th>
                      <th>Total Session</th>
                      <th>Total Chat</th>
                      <th>Total Notification</th>
                      <th>Total Note</th>
                      <th>Created</th>
                      <th>Updated</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {contacts?.map((item) => (
                  <tr
                    key={item.contactId}
                    className={`contact-row ${contactData?.contactId === item.contactId ? "active" : ""
                      }`}
                    onClick={() => {
                      setContactData(item);
                      setShowPreview(true);
                    }}
                  >
                    <td>
                      <div
                        className="d-flex align-items-center gap-2"
                        onMouseEnter={() => setHoverId(item.contactId)}
                        onMouseLeave={() => setHoverId(null)}
                      >
                        <div className="avatar-sm">
                          {hoverId === item.contactId || isChecked(item.contactId) ? (
                            <Form.Check
                              type="checkbox"
                              checked={isChecked(item.contactId)}
                              onChange={() => toggleSingle(item.contactId)}
                              onClick={(e) => e.stopPropagation()}
                            />
                          ) : (
                            item.name.charAt(0)
                          )}
                        </div>
                        <div>
                          <div className="fw-medium">{item.name}</div>
                          <small className="text-muted">{item.email}</small>
                        </div>
                      </div>
                    </td>
                    {!contactData && (
                      <>
                        <td>{item.phone || "_"}</td>
                        <td>{item.companyName || "_"}</td>
                        <td>{item.totalPageView || 0}</td>
                        <td>{item.totalSession || 0}</td>
                        <td>{item.totalMessage || 0}</td>
                        <td>{item.totalNotification || 0}</td>
                        <td>{item.totalNote || 0}</td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.createdAt}
                          </Moment>
                        </td>
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item?.updatedAt}
                          </Moment>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <div className={`preview-section ${showPreview ? "open" : ""}`}>
            {contactData && <ContactDetails currentUserData={currentUserData} contactId={contactData?.contactId} />}
          </div>
        </div>
      </div>
      <AddContact
        show={!toggles.toggle}
        hide={() => toggles.setToggle()}
        title={`Add Contact`}
        getContactList={getContactList}
      />
      <UpdateContact
        show={!toggles.toggle1}
        hide={() => toggles.setToggle1()}
        title={`Update Contact`}
        getContactList={getContactList}
        contactId={contactIds?.[0]}
      />
    </>
  );
};

export default ContactData;
